<template>
  <div class="invoiceDetails">
    <Nav :title="title"></Nav>
    <p class="tip" :class="{ isIosx: isiOSX }">
      电子发票与纸质发票具有同等效力
    </p>
    <div class="content">
      <div class="in">
        <div class="tt">
          <span class="title">抬头类型</span>
          <div @click="tabInvoice(2)">
            <img
              src="./../../assets/takingCar/unchecked.png"
              alt
              v-show="isfirm == 2"
            />
            <img
              src="./../../assets/takingCar/checked.png"
              alt
              v-show="isfirm == 1"
            />
            <span>个人/非企业抬头</span>
          </div>
          <div @click="tabInvoice(1)">
            <img
              src="./../../assets/takingCar/unchecked.png"
              alt
              v-show="isfirm == 1"
            />
            <img
              src="./../../assets/takingCar/checked.png"
              alt
              v-show="isfirm == 2"
            />
            <span>公司抬头</span>
          </div>
        </div>
        <van-cell-group>
          <van-field
            v-model="tt"
            label="发票抬头"
            placeholder="填写发票抬头"
            input-align="right"
            maxlength="30"
          />
          <van-field
            v-model="sh"
            label="发票税号"
            placeholder="请填写纳税人识别号"
            input-align="right"
            maxlength="20"
            v-if="isfirm == 2"
          />
          <van-field
            v-model="content"
            label="发票内容"
            placeholder="只读"
            input-align="right"
            class="readOnly"
            readonly
          />
          <van-field
            v-model="money"
            label="开票金额"
            placeholder="只读"
            input-align="right"
            class="readOnly"
            readonly
          />
          <div class="moneytip" @click="showMoneyTip" v-if="isexistyg">
            开票金额变少了
            <img src="./../../assets/takingCar/moneytip.png" alt="" />
          </div>
        </van-cell-group>

        <div class="more" v-if="isfirm == 2">
          <div>
            <span class="title">更多信息</span>
            <div @click="gomore">
              <img src="./../../assets/takingCar/moreright.png" alt="" />
              <span class="rightTip">{{ more }}</span>
            </div>
          </div>

          <p>{{ site }}</p>
          <p>{{ phone }}</p>
          <p>{{ bankOfDeposit }}</p>
          <p>{{ bankAccount }}</p>
          <p>{{ remark }}</p>
        </div>
      </div>
    </div>
    <div class="receiveMode">
      <p>接收方式</p>
      <van-cell-group>
        <van-field
          v-model="receiveMode"
          placeholder="请输入邮箱地址"
          @focus="keyboard"
        />
      </van-cell-group>
    </div>
    <div class="button" :class="{ keyboard: iskeyboard }">
      <button @click="showVerify">提交</button>
    </div>
    <!-- 确认发票弹框内容 -->
    <van-popup
      v-model="show"
      position="bottom"
      class="verify"
      round
      closeable
      close-icon-position="top-right"
    >
      <div v-if="!issubmit">
        <p class="title">发票信息</p>
        <div class="verifyContent">
          <p class="tiptext">
            您选择了{{ verifyList.length }}个行程，金额共计{{
              totalMoney | moneyFormat
            }}元
          </p>
          <div class="in">
            <div
              class="xclist"
              v-for="(item, index) in verifyList"
              :key="index"
            >
              <p>
                <img
                  src="./../../assets/takingCar/caocao.png"
                  alt
                  v-if="item.short_name == 'CaoCao'"
                />
                <img
                  src="./../../assets/takingCar/yangguang.png"
                  alt
                  v-if="item.short_name == 'YangGuang'"
                />
                {{ item.platform_name }}
              </p>
              <p class="xcmid">共1个行程</p>
              <p>金额 {{ item.invoiced_amount | moneyFormat }} 元</p>
            </div>
          </div>
          <p class="tiptext">基本信息</p>
          <div class="detail">
            <p>
              <span>发票类型</span>
              <span>电子发票</span>
            </p>
            <p>
              <span>发票抬头</span>
              <span>{{ tt.replace(/\s*/g, "") }}</span>
            </p>
            <p v-show="isfirm == 2">
              <span>发票税号</span>
              <span>{{ sh.toUpperCase().replace(/\s*/g, "") }}</span>
            </p>
            <p>
              <span>电子邮箱</span>
              <span>{{ receiveMode }}</span>
            </p>
          </div>
        </div>
        <div class="detailButton">
          <button class="cloce" @click="cloce">取消</button>
          <!-- <button @click="button" :disabled="isButton">确认提交</button> -->
          <van-button v-if="!isButton" @click="button">确认提交</van-button>
          <van-button loading v-if="isButton" loading-text="开票中..." />
        </div>
      </div>
      <div v-else class="buttonNext">
        <img src="./../../assets/takingCar/succeed.png" alt />
        <h2>提交成功</h2>
        <p>电子发票与行程单将于30分钟内发送到您的电子邮箱</p>
        <button @click="toHome">返回首页</button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Nav from "./nav";
export default {
  data() {
    return {
      title: "按照行程开票",
      isiOSX: false,
      tt: "",
      sh: "",
      content: "客运服务费",
      money: "6.0元",
      more: "请填写备注、地址等（非必填）",
      receiveMode: "",
      isfirm: 2,
      show: false,
      site: "",
      phone: "",
      bankOfDeposit: "",
      bankAccount: "",
      remark: "",
      verifyList: [
        // { name: "曹操出行", num: "一", money: "25.00" },
      ],
      issubmit: false,
      totalMoney: 0,
      cardataList: [],
      cccardata: {},
      ygcardata: {},
      receiver_phone: "",
      iskeyboard: false,
      isButton: false,
      isexistyg: false,
    };
  },
  components: { Nav },
  created() {
    document.body.scrollTop = 0;
    // firefox
    document.documentElement.scrollTop = 0;
    // safari
    window.pageYOffset = 0;
    this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    this.isiOSX = this.isIphoneX();
    this.verifyList = JSON.parse(sessionStorage.getItem("checkedArr"));
    this.addMoney();
    this.setcardata();
    // console.log(this.verifyList);
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // console.log(to);
      // console.log(from);
      if (from.path == "/takingCar/moreMsg") {
        console.log("更多");
        let formData = {};
        formData = JSON.parse(sessionStorage.getItem("formData"));
        vm.tt = formData.tt;
        vm.sh = formData.sh;
        vm.receiveMode = formData.receiveMode;
      }
    });
  },
  mounted() {
    if (
      this.$route.query.site ||
      this.$route.query.phone ||
      this.$route.query.bankOfDeposit ||
      this.$route.query.bankAccount ||
      this.$route.query.remark
    ) {
      this.site = this.$route.query.site ? this.$route.query.site : "";
      this.phone = this.$route.query.phone ? this.$route.query.phone : "";
      this.bankOfDeposit = this.$route.query.bankOfDeposit
        ? this.$route.query.bankOfDeposit
        : "";
      this.bankAccount = this.$route.query.bankAccount
        ? this.$route.query.bankAccount
        : "";
      this.remark = this.$route.query.remark ? this.$route.query.remark : "";
      this.more = "";
    }
  },
  filters: {
    moneyFormat(value) {
      var value = Math.round(parseFloat(value) * 100) / 100;
      var xsd = value.toString().split(".");
      if (xsd.length == 1) {
        value = value.toString() + ".00";
        return value;
      }
      if (xsd.length > 1) {
        if (xsd[1].length < 2) {
          value = value.toString() + "0";
        }
        return value;
      }
    },
  },
  methods: {
    // 总价钱计算
    addMoney() {
      for (let i = 0; i < this.verifyList.length; i++) {
        this.totalMoney =
          this.totalMoney + parseFloat(this.verifyList[i].invoiced_amount);
      }
      this.money = this.moneyFormat(this.totalMoney) + "元";
    },
    moneyFormat(value) {
      var value = Math.round(parseFloat(value) * 100) / 100;
      var xsd = value.toString().split(".");
      if (xsd.length == 1) {
        value = value.toString() + ".00";
        return value;
      }
      if (xsd.length > 1) {
        if (xsd[1].length < 2) {
          value = value.toString() + "0";
        }
        return value;
      }
    },
    // 后台所需开票数据
    setcardata() {
      console.log(this.verifyList);
      // caocao
      let cc = 0;
      let yg = 0;
      let platform_id = 10;
      let short_name = "CaoCao";
      let external_order_sn_s = [];
      let invoiced_amount = 0;
      // yangguang
      let ygplatform_id = 20;
      let ygshort_name = "YangGuang";
      let ygexternal_order_sn_s = [];
      let yginvoiced_amount = 0;
      //
      let order_amount = this.totalMoney.toString();
      this.verifyList.forEach((item) => {
        console.log(item.short_name);
        this.receiver_phone = item.passenger_phone;
        if (item.short_name == "CaoCao") {
          cc = 1;
          platform_id = item.platform_id;
          short_name = item.short_name;
          external_order_sn_s.push(item.external_order_sn);
          // 可开票金额
          invoiced_amount = item.invoiced_amount + invoiced_amount;
        }
        if (item.short_name == "YangGuang") {
          this.isexistyg = true;
          console.log(item.external_order_sn);
          yg = 1;
          ygplatform_id = item.platform_id;
          ygshort_name = item.short_name;
          ygexternal_order_sn_s.push(item.external_order_sn);
          // 可开票金额
          yginvoiced_amount = item.invoiced_amount + yginvoiced_amount;
        }
      });
      // cacao
      this.cccardata.platform_id = platform_id;
      this.cccardata.short_name = short_name;
      this.cccardata.external_order_sn_s = external_order_sn_s.toString();
      // this.cccardata.order_amount = order_amount;
      this.cccardata.invoiced_amount = invoiced_amount;
      // yangguang
      this.ygcardata.platform_id = ygplatform_id;
      this.ygcardata.short_name = ygshort_name;
      this.ygcardata.external_order_sn_s = ygexternal_order_sn_s.toString();
      // this.ygcardata.order_amount = order_amount;
      this.ygcardata.invoiced_amount = yginvoiced_amount;
      if (cc == 1) {
        this.cardataList.push(this.cccardata);
      }
      if (yg == 1) {
        this.cardataList.push(this.ygcardata);
      }
    },
    // 公司he个人参数不同
    tabInvoice(type) {
      if (type == 1) {
        // console.log("公司类型");
        this.isfirm = 2;
      } else {
        // console.log("个人类型");
        this.isfirm = 1;
        this.sh = "";
        this.site = "";
        this.phone = "";
        this.bankOfDeposit = "";
        this.bankAccount = "";
        this.remark = "";
      }
    },
    keyboard() {
      // 判断是否为ios
      // console.log("1111");
      var u = navigator.userAgent;
      if (u.indexOf("iPhone") > -1 || u.indexOf("iOS") > -1) {
        //IOS
        // console.log("ios")
      } else {
        //安卓
        this.iskeyboard = true;
        // console.log(this.iskeyboard)
        window.setTimeout(function () {
          document.activeElement.scrollIntoView({ block: "center" });
        }, 200);
      }
    },
    // 更多信息
    gomore() {
      let formData = {
        tt: this.tt,
        sh: this.sh,
        receiveMode: this.receiveMode,
      };
      sessionStorage.setItem("formData", JSON.stringify(formData));
      this.$router.push({
        path: "/takingCar/moreMsg",
        query: {
          site: this.site,
          phone: this.phone,
          bankOfDeposit: this.bankOfDeposit,
          bankAccount: this.bankAccount,
          remark: this.remark,
        },
      });
    },
    // 提交
    showVerify() {
      var reg = new RegExp(
        "^[a-z0-9A-Z]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"
      ); //正则表达式
      if (this.isfirm == 2) {
        // 公司
        if (this.tt == "") {
          this.$toast("请填写发票抬头");
        } else if (this.sh == "") {
          this.$toast("请填写发票税号");
        } else if (this.sh.length < 15) {
          this.$toast("纳税人识别号格式不正确,请填入15-20位数字或大写字母");
        } else if (this.receiveMode == "") {
          this.$toast("请填写邮箱地址");
        } else if (!reg.test(this.receiveMode)) {
          this.$toast("请填写正确邮箱地址");
        } else {
          this.show = true;
        }
      } else {
        // 个人
        if (this.tt == "") {
          this.$toast("请填写发票抬头");
        } else if (this.receiveMode == "") {
          this.$toast("请填写邮箱地址");
        } else if (!reg.test(this.receiveMode)) {
          this.$toast("请填写正确邮箱地址");
        } else {
          this.show = true;
        }
      }
    },
    // 取消
    cloce() {
      this.show = false;
    },
    // 确认提交
    button() {
      // 防重复点击
      this.isButton = true;
      setTimeout(() => {
        this.isButton = false;
      }, 3000);

      this.$api
        .post("taxis/member/invoice/apply", {
          title_type: this.isfirm,
          invoice_title: this.tt.replace(/\s*/g, ""),
          tax_num: this.sh.toUpperCase().replace(/\s*/g, ""),
          content: "客运服务费",
          address: this.site,
          company_phone: this.phone,
          open_bank: this.bankOfDeposit,
          bank_account: this.bankAccount,
          remark: this.remark,
          email_address: this.receiveMode.replace(/\s*/g, ""),
          receiver_name: "销巴生活",
          receiver_phone: this.receiver_phone,
          invoice_type: "0",
          data: this.cardataList,
        })
        .then((res) => {
          // console.log(res);
          if ((res.message = "success")) {
            this.issubmit = true;
          }
        })
        .catch((res) => {
          // console.log(res);
          this.$toast(res.message || res.receiver_name[0]);
        });
    },
    // 返回首页
    toHome() {
      console.log("返回首页");
      this.params("", "", "toHome");
      this.show = false;
      this.issubmit = false;
    },
    // 输入框监听
    iptListener() {
      window.addEventListener("resize", function () {
        console.log(1111);
        if (
          document.activeElement.tagName === "INPUT" ||
          document.activeElement.tagName === "TEXTAREA"
        ) {
          window.setTimeout(function () {
            document.activeElement.scrollIntoViewIfNeeded();
          }, 0);
        }
      });
    },
    // 发票金额为什么减少弹窗
    showMoneyTip() {
      this.$dialog
        .alert({
          message:
            "<p>根据阳光出行平台规定，费用中<span>除客运服务费之外</span>的费用（<span>如停车费和高速费等</span>）不支持开具电子发票。</p><p>若要开具该项费用的发票，您可以与司机师傅沟通，<span>自行保存纸质发票</span>。</p>",
          confirmButtonText: "知道了",
          confirmButtonColor: "#F9591B",
          messageAlign: "left",
          className: "dialog",
          allowHtml: true,
        })
        .then(() => {});
    },
  },
};
</script>

<style lang="less">
.dialog {
  .van-dialog__content {
    color: #333333;
    font-size: 14px;
    line-height: 23px;
    p {
      span {
        color: #f9591b;
      }
    }
    p:last-child {
      margin-top: 10px;
    }
  }
}
.invoiceDetails {
  background: #f5f6f7;
  min-height: 100%;

  .tip {
    margin-top: 70px;
    height: 18px;
    background: #fff7e4;
    color: #b78100;
    font-size: 13px;
    line-height: 18px;
    text-align: center;
    padding: 9px 0;
  }
  .isIosx {
    margin-top: 90px;
  }
  .content {
    background: #ffffff;
    .in {
      margin: 0px 15px 0;
      .tt {
        height: 21px;
        padding: 20px 0;
        border-bottom: 0.5px solid #dddddd;
        overflow: hidden;
        .title {
          font-weight: bolder;
          margin-right: 63px;
          float: left;
        }
        @media screen and (max-width: 389px) {
          .title {
            margin-right: 20px;
          }
        }
        @media screen and (max-width: 342px) {
          .title {
            margin-right: 0px;
          }
        }
        div {
          float: right;
          overflow: hidden;
          img {
            float: left;
            width: 12px;
            height: 12px;
            margin: 4.5px 3px 0px 13px;
          }
          span {
            float: left;
            color: #333333;
            font-size: 15px;
            line-height: 21px;
          }
        }
      }
      .van-cell-group {
        // border: 1px solid red;
        position: relative;
        .van-cell {
          padding: 20px 0;
          border-bottom: 0.5px solid #dddddd;
          .van-cell__title {
            color: #333333;
            font-weight: bolder;
            font-size: 15px;
            line-height: 21px;
          }
          .van-field__control:disabled {
            color: #333333;
          }
          // .readOnly{
          //   color: red;
          // }
        }
        .van-cell::after {
          border-bottom: none;
        }
        // .van-cell:last-child {
        //   border-bottom: none;
        // }
        .moneytip {
          color: #b78100;
          position: absolute;
          right: 0;
          bottom: 5px;
          font-size: 11px;
          line-height: 16px;
          img {
            width: 11px;
            height: 11px;
            transform: translateY(1px);
          }
        }
      }
      .more {
        padding: 20px 0;
        // border-top: 0.5px solid #dddddd;
        font-size: 15px;
        line-height: 21px;
        color: #333333;

        div {
          font-weight: bolder;
          overflow: hidden;
          margin-bottom: 5px;
          .title {
            float: left;
          }
          div {
            float: right;
            height: 21px;
            .rightTip {
              float: right;
              color: #999999;
              font-weight: normal;
              width: 210px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              word-break: keep-all;
            }
            img {
              width: 9px;
              height: 9px;
              float: right;
              transform: translateY(5px);
            }
          }
        }
        p {
          margin-top: 5px;
          color: #999999;
          line-height: 21px;
        }
      }
    }
  }
  .receiveMode {
    margin-bottom: 40px;
    p {
      color: #999999;
      font-size: 13px;
      line-height: 18px;
      margin: 20px 0 20px 15px;
    }
    .van-cell {
      padding: 20px 15px;
    }
  }
  .button {
    width: 100%;
    height: 80px;
    overflow: hidden;
    button {
      float: left;
      margin-left: 3%;
      margin-top: 15px;
      width: 94%;
      align-items: center;
      background: #181818;
      color: #ffffff;
      font-size: 18px;
      line-height: 25px;
      height: 50px;
      border-radius: 5px;
      border: none;
    }
  }
  .keyboard {
    margin-bottom: 300px;
  }
  .verify {
    min-height: 397px;
    .title {
      color: #333333;
      font-size: 16px;
      line-height: 22px;
      text-align: center;
      margin: 20px 0;
      font-weight: bolder;
    }
    .verifyContent {
      margin: 0 15px;
      .tiptext {
        color: #999999;
        font-size: 13px;
        line-height: 18px;
        margin: 10px 5px;
      }
      .in {
        background: #f5f6f7;
        border-radius: 3px;
        padding: 15px 15px 0;
        max-height: 99px;
        overflow: auto;
        // overflow-x: hidden;
        // overflow-y: scroll;

        .xclist {
          position: relative;
          // border: 1px solid red;
          height: 33px;
          p {
            color: #333333;
            font-size: 13px;
            line-height: 18px;
            margin: 0px 0px 15px;

            img {
              width: 16px;
              height: 16px;
              margin-right: 4px;
              transform: translateY(3px);
            }
          }
          p:nth-child(1) {
            position: absolute;
            top: -3px;
            left: 0;
          }
          .xcmid {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
          }
          p:nth-child(3) {
            position: absolute;
            top: 0;
            right: 0;
          }
        }
      }
      .detail {
        padding: 15px 0 1px;
        background-color: #f5f6f7;
        border-radius: 3px;
        p {
          font-size: 13px;
          line-height: 18px;
          margin: 0 0px 15px 20px;
          display: flex;

          span:nth-child(n) {
            color: #666666;
            margin-right: 30px;
            white-space: nowrap;
          }
          span:nth-child(2n) {
            color: #333333;
            font-weight: bold;
            flex: 1;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
    .detailButton {
      height: 50px;
      margin: 20px 0;
      button {
        height: 50px;
        width: 44%;
        border-radius: 5px;
        background: #181818;
        color: #ffffff;
        font-size: 18px;
        font-weight: bold;
        border: none;
      }
      .cloce {
        margin: 0 4% 0;
        border: 1px solid #181818;
        background: #ffffff;
        color: #181818;
      }
      button:last-child {
        transform: translateY(-1px);
      }
    }
    .buttonNext {
      position: relative;
      margin: 0 15px;
      img {
        width: 63.6px;
        height: 63.6px;
        margin-top: 70px;
        margin-left: 50%;
        transform: translateX(-32.8px);
      }
      h2 {
        text-align: center;
        color: #333333;
        font-size: 18px;
        line-height: 25px;
        margin: 15px 0;
      }
      p {
        color: #999999;
        font-size: 13px;
        line-height: 18px;
        text-align: center;
      }
      button {
        position: fixed;
        left: 5%;
        bottom: 20px;
        height: 50px;
        color: #ffffff;
        background: #181818;
        border-radius: 5px;
        width: 90%;
        border: none;
      }
    }
  }
}
</style>
